import React from 'react';
import { APPOINTMENT_CARD_TYPE } from '@/constants/enums';
import ResumeBookingCard from './ResumeBookingCard';
import UpcomingBookingCard from './UpcomingBookingCard';

const UserCard = ({ cardData }: { cardData: any }) => {
    const isUpcomingBooking =
        cardData?.cardType === APPOINTMENT_CARD_TYPE.VIEW_BOOKING;

    if (isUpcomingBooking) {
        return <UpcomingBookingCard cardData={cardData} />;
    }

    return <ResumeBookingCard cardData={cardData} />;
};

export default UserCard;
export { ResumeBookingCard, UpcomingBookingCard };
